/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import Rightlogo from "../../assets/img/rightlogo.png";

// reactstrap components
import {
  Navbar,
  NavbarToggler
} from "reactstrap";

function AdminNavbar(props) {
  const [color, setcolor] = React.useState("navbar-transparent");
  React.useEffect(() => {
    window.addEventListener("resize", setcolor("navbar-transparent"));
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", setcolor("navbar-transparent"));
    };
  },[setcolor]);

  return (
    <>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg" style={{ paddingTop: "25px; !important", paddingBottom: "25px;" }}>
        <div className="row col-md-12 col-sm-12 col-xs-12 navStyle hidden-xs" style={{ padding: 0 }}>
          <div className="col-md-6 col-sm-12" style={{ textAlign: "right" }}>
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}

              style={{ float: "right" }}
            >
              <NavbarToggler type="button" onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <div>
              <img className="RightLogo" src={Rightlogo} alt="Rightlogo" />
              <h4 style={{ display: "inline", marginRight: "10px" }} className="hidden-xs">
                {props.siteHeader}
              </h4>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <h4 style={{ display: "inline", marginLeft: "10px" }}>
            {props.siteTitle}
            </h4>
            <img className="RightLogo" src={props.siteLogoUrl} alt="Leftlogo" />
          </div>
        </div>

        <div className=" col-xs-12 navStyle show-xs" style={{ padding: 0 }}>
          <div className="col-xs-2">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}

              style={{ float: "right", display: "inline" }}
            >
              <NavbarToggler type="button" onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
          </div>
          <div className="col-xs-8" style={{ textAlign: "center" }}>
            <div className="col-xs-12">
              <img className="RightLogo" src={props.siteLogoUrl} alt="Leftlogo" />
            </div>
            <div className="col-xs-12">
              <h4>
               {props.siteTitle}
            </h4>
            </div>
            <div className="col-xs-12">
              <h6>
              {props.siteHeader}
              </h6>
            </div>
          </div>
          <div className="col-xs-2">
          </div>

        </div>

      </Navbar>
    </>
  );
}

export default AdminNavbar;
